import React from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import PackActions from '../actions/PackActions';
import AuthStore from '../stores/AuthStore';
import StateStore from '../stores/StateStore';
import ProductListItem from './ProductListItem';
import { buildTable } from './Boxes';
import ProgressBar from './ProgressBar';
import Popup from 'react-popup';
import '../utils/Polyfill.js'
require('./Multiselect')

function getProductListItem(product, parent, group_treshold) {
  let supercount = product.product_uom_qty >= group_treshold
  let k = 1
  if(product.product_uom_qty % 1 != 0){
    k++
    return (<ProductListItem
             key={product.line_id+'.'+product.product_id+'.'+k}
             product={product}
             qty={product.product_uom_qty}
             supercount={false}
             parent={parent}/>
    )
  } else if (supercount){
    k++
    return (<ProductListItem
             key={product.line_id+'.'+product.product_id+'.'+k}
             product={product}
             qty={product.product_uom_qty}
             supercount={supercount}
             parent={parent}/>
    )
  } else {
    let arr = []
    for (var i = 1; i <= product.product_uom_qty; i++) {
      k++
      arr.push(<ProductListItem
                key={product.line_id+'.'+product.product_id+'.'+k}
                product={product}
                qty={1}
                supercount={supercount}
                parent={parent}/>
      )
    }
    return arr
  }

}

class PakowanieComponent extends React.Component {

  constructor() {
    super();
    let order = StateStore.getOrder()
    this.state = {
      order: order,
      config: AuthStore.getConfig(),
      pack: StateStore.getPack(),
      pack_important: StateStore.getPackImportant(),
      scanned_code: StateStore.getScannedCode(),
      uid: AuthStore.getUser().id,
      pakowalnia_id: AuthStore.getPakowalnia(),
      order_code: Object.keys(StateStore.getVariants())[0],
      valid: false,
      progress: 0,
      multi_delivery: order && order.products &&
                      order.products.reduce((n, p)=>{ return n + (p.product_type == 'service') }, 0) > 1
    }
    this.onChange = this.onChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleScanner = this.handleScanner.bind(this)
    this.noteCheckboxClick = this.noteCheckboxClick.bind(this)
    this.toggleConfirmButton = this.toggleConfirmButton.bind(this)
    this.confirmCarrierChange = this.confirmCarrierChange.bind(this)
    this.deselectOrder = this.deselectOrder.bind(this)
    this.addPackage = this.addPackage.bind(this)
    this.addDelivery = this.addDelivery.bind(this)
  }

  processPakowanie = (values) => {
    const { kartony } = this.state.config
    if (kartony && kartony.length > 0){
      Popup.plugins().multiselect(intl.get('Wybierz dodatkowe elementy'),
        kartony,
        function (selected) {
          values.wh_costs = selected
          PackActions.processPakowanie(values)
        })
    } else {
      PackActions.processPakowanie(values)
    }
  }

  onChange() {
    let order = StateStore.getOrder()
    this.setState({
      order: order,
      scanned_code: StateStore.getScannedCode(),
      multi_delivery: order && order.products &&
                      order.products.reduce((n, p)=>{ return n + (p.product_type == 'service') }, 0) > 1
    });
  }

  componentWillMount() {
    StateStore.addChangeListener(this.onChange)
  }

  componentDidMount() {
    if(!this.state.order){
      PackActions.recieveOrder(this.state.order_code, this.state.uid, this.state.pakowalnia_id, this.state.pack)
    }
    let scanner = document.getElementById('scanner')
    if (scanner){
      scanner.focus()
    }
    this.toggleConfirmButton()
  }

  componentDidUpdate() {
    // auto select
    if(this.state.order && this.state.config.auto_select_all){
      document.querySelectorAll('.checkbox').forEach(el => el.classList.add('checked'))
    } else if (this.state.order && this.state.config.auto_select && this.state.scanned_code && !document.querySelector('.mainCheckbox.checked')){
      let input = document.createElement('input')
      input.value = this.state.scanned_code
      input.onkeydown = this.handleScanner
      var ev = new KeyboardEvent('keydown', { altKey:false,
                                              charCode: 0,
                                              code: 'Enter',
                                              composed: true,
                                              ctrlKey: false,
                                              key: 'Enter',
                                              keyCode: 13,
                                              location: 0,
                                              shiftKey: false,
                                              type: 'keydown',
                                              which: 13})
      input.dispatchEvent(ev);
    }
    if(this.state.order){
      this.toggleConfirmButton()
    }
  }

  componentWillUnmount() {
    StateStore.removeChangeListener(this.onChange)
  }

  handleSubmit(event) {
    event.preventDefault();
    let self = this
    let values = {}
    document.querySelectorAll('input').forEach(input => {
      if(input.type == 'radio' && !input.checked){ return }
      let val = input.value
      if ((val != '') && !isNaN(val)){ val = parseInt(val) }
      if(input.type == 'checkbox'){
    	   val = input.checked
      }
      values[input.name] = val
    })
    if(document.querySelector('.mainCheckbox.service')){
      values.shipping_lines = [...document.querySelectorAll('.mainCheckbox.service:not(.checked)')].map((o)=>{
                                return parseInt(o.getAttribute('data-line'))
                              })
    }
    if((values['carrier_id'] || this.state.order.carrier_id) && this.state.order['inpost_no_size'] &&
       this.state.config.inpost_dostawy.includes(values['carrier_id'] || this.state.order.carrier_id)){
         Popup.create({
           content: intl.get('Wybierz gabaryt paczki'),
           buttons: {
             right: [{
               text: 'A',
               action: function () {
                 Popup.close()
                 values['inpost_size'] = 'A'
                 self.processPakowanie(values)
               }
             },{
               text: 'B',
               action: function () {
                 Popup.close()
                 values['inpost_size'] = 'B'
                 self.processPakowanie(values)
               }
             },{
               text: 'C',
               action: function () {
                 Popup.close()
                 values['inpost_size'] = 'C'
                 self.processPakowanie(values)
               }
             },
             {
               text: intl.get('Anuluj'),
               className: 'cancel-button',
               action: function () {
                 Popup.close()
               }
             }]
           }
         })
    } else {
        self.processPakowanie(values)
    }
  }

  deselectOrder() {
    PackActions.deselectOrder(this.state.order.id)
  }

  confirmCarrierChange(e){
    let self = this
    let label = e.currentTarget
    let radio = document.getElementById(label.getAttribute('for'))
    if (radio.checked){
      return
    }
    if (!label.classList.contains('initial')){
      e.preventDefault()
      Popup.create({
        content: intl.get('Na pewno chcesz zmienić dostawcę dla tego zamówienia?'),
        buttons: {
          right: [{
            text: intl.get('Tak'),
            key: 'enter',
            action: function () {
              Popup.close()
              radio.click()
              let order = self.state.order
              order.carrier_id = parseInt(label.getAttribute('data-value'))
              order.carrier_name = label.innerText
              self.setState({
                order: order
              })
            }
          },
          {
            text: intl.get('Anuluj'),
            className: 'cancel-button',
            action: function () {
              Popup.close()
            }
          }]
        }
      })
    }
  }

  handleScanner(event){
    if (event.which == 13) {
      let ean = event.target.value
      let checkbox = document.querySelector('.produkt:not(.grey):not(.has_bundle)[data-barcode="'+ean+'"] .checkbox:not(.checked), .produkt:not(.grey) .bundleItemList tr[data-barcode="'+ean+'"] .checkbox:not(.checked)')
      if(!checkbox){
        if(event.target.id == 'scanner'){
          Popup.create({
            content: intl.get('Nie znaleziono produktu z tym kodem.'),
            buttons: {
              right: [{text: 'OK',
                      className: 'ok',
                      key: 'enter',
                      action: function () {
                        Popup.close()
                        document.getElementById('scanner').value = ''
                        document.getElementById('scanner').focus()
                      }}]
            }
          })
        }
      } else {
        var parent = checkbox.closest('.produkt.ramka')
        if(!parent.querySelector('.bundleItemList') || !checkbox.closest('.product_checkbox')){
          var cnt = parent.getAttribute('data-prods')
          let bundle_cnt = false
          if(checkbox.classList.contains('multiproduct')){
            bundle_cnt = checkbox.closest('tr').getAttribute('data-qty')
            cnt = cnt+' x '+bundle_cnt
          }
          if((!parent.classList.contains('supercount') && !bundle_cnt) || checkbox.classList.contains('checked') || confirm(intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', {cnt: cnt}))){
              checkbox.classList.toggle('checked')
              if(this.state.config.product_folding){
                parent.classList.add('foldable')
                parent.classList.add('folded')
              }
              if(this.state.config.last_scanned){
                  document.querySelectorAll('.produkt').forEach(el => el.classList.remove('last_scanned'))
                  checkbox.closest('[data-barcode]').classList.add('last_scanned')
                  document.querySelector('.pakowanie_products').scrollTop = checkbox.closest('[data-barcode]').offsetTop - 100
              }
              if(parent.querySelector('.bundleItemList')){
                parent.querySelector('.product_checkbox .checkbox').classList.toggle('checked', !parent.querySelector('.bundleItemList .checkbox:not(.checked)'))
              }
              this.toggleConfirmButton()
          }
        }
        event.target.value = ''
      }
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }

  noteCheckboxClick(event){
    event.currentTarget.classList.toggle('checked')
    this.toggleConfirmButton()
  }

  toggleConfirmButton(){
    let state = {}
    if(!document.querySelector('.produkt:not(.grey) .mainCheckbox:not(.service):not(.checked), .mainCheckbox.uwagiCheckbox:not(.checked)')
       && !document.querySelector('.produkt:not(.grey) .productVariantValue.proper:not(.selected)')){
      state.valid = true
    } else {
      state.valid = false
    }
    //Progress
    let all = document.querySelectorAll('.produkt:not(.grey) .mainCheckbox:not(.service), .mainCheckbox.uwagiCheckbox').length
    let checked = 0
    if(document.querySelector('.mainCheckbox.uwagiCheckbox.checked')){
      checked += 1
    }
    document.querySelectorAll('.produkt:not(.grey) .mainCheckbox:not(.service).checked').forEach((item) => {
      if (!item.querySelector('.productVariantValue.proper:not(.selected)')){
        checked += 1
      }
    })
    //opcja KW
    if(document.querySelector('.mainCheckbox.service')){
      all += 1
      if(document.querySelector('.mainCheckbox.service.checked')){
        checked += 1
      }
      if(all == checked){
        state.valid = true
      } else {
        state.valid = false
      }
    }
    state.progress = checked / all * 100
    if(all === 0){
      state.progress = 100
      state.valid = true
    }
    if(state.progress != this.state.progress || state.valid != this.state.valid){
      this.setState(state)
    }
  }

  addDelivery(e){
    e.preventDefault()
    let self = this
    Popup.create({
      content: intl.get('Jesteś pewien?'),
      buttons: {
        right: [{
          text: intl.get('Tak'),
          key: 'enter',
          action: function () {
            Popup.close()
            if(document.querySelector('.carriers_radios') && !document.querySelector('input[name=carrier_id]:checked')){
              Popup.alert(intl.get('Musisz wybrać metodę dostawy'))
              return
            }
            let carrier = parseInt(document.querySelector('input[name=carrier_id]:checked, input[type="hidden"][name="carrier_id"]').value)
            document.querySelector('.loaderWrap').style.display = 'block'
            PackActions.addDelivery(self.state.order.id, carrier, self.state.uid, self.state.pakowalnia_id)
          }
        },
        {
          text: intl.get('Anuluj'),
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  addPackage(e){
    e.preventDefault()
    let self = this
    Popup.create({
      content: intl.get('Jesteś pewien?'),
      buttons: {
        right: [{
          text: intl.get('Tak'),
          key: 'enter',
          action: function () {
            Popup.close()
            if(document.querySelector('.carriers_radios') && !document.querySelector('input[name=carrier_id]:checked')){
              Popup.alert(intl.get('Musisz wybrać metodę dostawy'))
              return
            }
            let carrier = parseInt(document.querySelector('input[name=carrier_id]:checked, input[type="hidden"][name="carrier_id"]').value)

            //gabaryt
            let inpost_size = false
            if(carrier &&
               self.state.config.inpost_dostawy.includes(carrier || self.state.order.carrier_id)){
                 Popup.create({
                   content: intl.get('Wybierz gabaryt paczki'),
                   buttons: {
                     right: [{
                       text: 'A',
                       action: function () {
                         Popup.close()
                         inpost_size = 'A'
                         document.querySelector('.loaderWrap').style.display = 'block'
                         PackActions.addPackage(self.state.order.id, carrier, self.state.uid, self.state.pakowalnia_id, inpost_size)
                       }
                     },{
                       text: 'B',
                       action: function () {
                         Popup.close()
                         inpost_size = 'B'
                         document.querySelector('.loaderWrap').style.display = 'block'
                         PackActions.addPackage(self.state.order.id, carrier, self.state.uid, self.state.pakowalnia_id, inpost_size)
                       }
                     },{
                       text: 'C',
                       action: function () {
                         Popup.close()
                         inpost_size = 'C'
                         document.querySelector('.loaderWrap').style.display = 'block'
                         PackActions.addPackage(self.state.order.id, carrier, self.state.uid, self.state.pakowalnia_id, inpost_size)
                       }
                     },
                     {
                       text: intl.get('Anuluj'),
                       className: 'cancel-button',
                       action: function () {
                         Popup.close()
                       }
                     }]
                   }
                 })
            } else {
              document.querySelector('.loaderWrap').style.display = 'block'
              PackActions.addPackage(self.state.order.id, carrier, self.state.uid, self.state.pakowalnia_id)
            }
          }
        },
        {
          text: intl.get('Anuluj'),
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  render() {
    let order
    let config = this.state.config
    let odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')
    if (this.state.order) {order = this.state.order}
    return (
      <div className="pakowanie">
        <style dangerouslySetInnerHTML={{__html: `
          #app header, #app footer{ display: none }
          #app{ display: block }
        `}} />
        <div>
          <div className="pakowanie_header">
            <button className="pull-left" onClick={this.deselectOrder}>{intl.get('Wstecz')}</button>
            {config.productscan &&
              <div className="scanner_wrapper">
                <input id="scanner"
                       type="text"
                       name="scanner"
                       placeholder={intl.get('wprowadź kod produktu')}
                       onKeyPress={this.handleScanner}
                       autoComplete="off"/>
              </div>
            }
            {config.wydruk_kw &&
              <div className="wydruk_kw_wrapper">
                <input type="checkbox" name="wydruk_kw" id="wydruk_kw"/>
                <label htmlFor="wydruk_kw">{intl.get('Wydruk KW')}</label>
              </div>
            }
            <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" disabled={!this.state.valid} >{intl.get('Dalej')}</button>
          </div>
          <ProgressBar percent={this.state.progress}/>
          {order &&
            <div className="pakowanie_content row">
              <input type="hidden" name="order" value={order.id}/>
              <input type="hidden" name="paczka" value={this.state.pack}/>
              <input type="hidden" name="pakowalnia" value={this.state.pakowalnia_id}/>
              <div className="col-lg-4">
                <div className="pakowanie_order ramka">
                  <h4>{intl.get('Zamówienie')} {order.name}</h4>
                  <div className="order_data">
                    <div className="notes">
                      {config.note_checkbox && order.note &&
                        (!config.note_checkbox_important || this.state.pack_important) &&
                          <div className="checkbox mainCheckbox uwagiCheckbox" onClick={this.noteCheckboxClick}>
                            <div className="checkbox-inner"></div>
                          </div>
                      }
                      <label>{intl.get('Uwagi klienta')}:</label>
                      <div>{order.note}</div>
                    </div>
                    <div className="carrier">
                      <label>{intl.get('Metoda dostawy')}:</label>
                      {config.carrier_selection && order.carriers &&
                        <div className="carriers_radios">
                          {order.carriers.map(carrier => {
                            return(<div className="carrier_radio" key={carrier.id}>
                              <div className="carrier_thumbnail" style={{color: '#ccc', backgroundImage: `url("${odoo}/web/delivery_carrier_image?carrier_id=${carrier.id || ''}")`}}/>
                              <input type="radio"
                                     name="carrier_id"
                                     id={'carrier_'+carrier.id}
                                     value={carrier.id}
                                     defaultChecked={order.carrier_id == carrier.id ? 'checked':''}/>
                              <label className={order.carrier_id == carrier.id ? 'initial':''}
                                     htmlFor={'carrier_'+carrier.id}
                                     onClick={this.confirmCarrierChange} data-value={carrier.id}>{carrier.name}</label>
                            </div>)
                          })}
                        </div>
                      }
                      {!config.carrier_selection &&
                        <span>{order.carrier_name}</span>
                      }
                      {!config.carrier_selection &&
                        <div>
                          <label></label>
                          <input type="hidden" name="carrier_id" value={order.carrier_id || ''}/>
                          {order.carrier_id &&
                            <span className="shippinglogo">
                                <img src={`${odoo}/web/delivery_carrier_image?carrier_id=${order.carrier_id || ''}`} /><br/>
                            </span>
                          }
                        </div>
                      }
                      {(config.add_package || config.add_delivery) &&
                        <div className="add_package_wrapper">
                          {config.add_delivery &&
                            <button id="add_delivery" onClick={this.addDelivery}>{intl.get('Dodaj przesyłkę')}</button>
                          }
                          {config.add_package &&
                            <button id="add_package" onClick={this.addPackage}>{intl.get('Dodaj paczkę')}</button>
                          }
                        </div>
                      }
                    </div>

                    <label>{intl.get('Data zamówienia')}:</label>
                    <span>{order.date_order}</span><br/>
                    <label>{intl.get('Kwota zamówienia')}:</label>
                    <span>{order.amount_total}</span><br/>
                    <label>{intl.get('Adres dostawy')}:</label>
                    <span>{order.delivery_name}</span><br/>
                    <label></label>
                    <span>{order.delivery_street}</span><br/>
                    <label></label>
                    <span>{order.delivery_zip} {order.delivery_city}</span><br/>
                    <label>{intl.get('Potwierdzenie')}:</label>
                    <span>{order.invoice_option ? intl.get('faktura') : intl.get('paragon')}</span><br/>
                    {order.allegro_account &&
                      <div>
                        <label>{intl.get('Login Allegro sprzedawcy')}:</label>
                        <span>{order.allegro_account}</span>
                      </div>
                    }
                    {order.allegro_client_login &&
                      <div>
                        <label>{intl.get('Login Allegro klienta')}:</label>
                        <span>{order.allegro_client_login}</span><br/>
                      </div>
                    }
                    <label>{intl.get('Osoba zbierająca')}:</label>
                    <span>{order.warehouseman}</span><br/>
                    {order.box_number2 &&
                      <div className="box_info">
                        <label>{intl.get('Numer wózka')}:</label>
                        <span>{order.cart_number}</span><br/>
                        <label>{intl.get('Miejsce w wózku')}:</label><br/>
                        <table className="boxy">
                          {buildTable(order.box_number2)}
                        </table>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className={'pakowanie_products col-lg-8'+(order.products.length>3?' many_products':'')}
                   data-view={this.state.config.product_list_view || 'kanban'}>
                {order.products.map(product => getProductListItem(product, this, (this.state.config.group_treshold || 10)))}
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(PakowanieComponent);



// WEBPACK FOOTER //
// ./src/components/Pakowanie.js